<script>
  import { t } from '../i18n.js'
  import SwaggerUI from '../components/SwaggerUI.svelte'
  import BaseButton from '../components/common/BaseButton.svelte'
  import TextInput from '../components/common/TextInput.svelte'
  import TextArea from '../components/common/TextArea.svelte'
  import RadioButton from '../components/common/RadioButton.svelte'
  import ViewCardContainer from '../components/ViewCardContainer.svelte'
  import AlertBox from '../components/common/AlertBox.svelte'
  import { onMount } from 'svelte'
  import { startAuth } from '../login.js'
  import LoginIcon from '../assets/icons/LoginIcon.svelte'
  import BringDataIconBg from '../assets/BringDataIconBg.svelte'
  import CopyToClipboard from '../components/common/CopyToClipboard.svelte'
  import { errorBox } from '../store/stores.js'
  import {link} from 'svelte-spa-router'


  let isLoggedIn
  let accessToken
  onMount(() => {
  isLoggedIn = localStorage.getItem('isLoggedIn')
  accessToken = localStorage.getItem('accessToken')
  })

  onMount(() => {
  window.scrollTo(0,0)
  })
  const checkIfHasAccess = () => {
  const localStorageGroups = localStorage.getItem('userGroups')
  const dataImportAccessGroupId = 'internaldev'
  return localStorageGroups.includes(dataImportAccessGroupId)
  }

  let formInputs = [
  {
  val: '',
  id: 'first-name',
  label: 'dataimport.first-name',
  placeholder: 'Kalle',
  required: true
  },
  {
  val: '',
  id: 'last-name',
  label: 'dataimport.last-name',
  placeholder: 'Koodari',
  required: true
  },
  {
  val: '',
  id: 'email',
  label: 'dataimport.email',
  placeholder: 'kalle.koodari@mail.com',
  required: true
  },
  {
	val: '',
	id: 'description',
	label: 'dataimport.description-label',
	placeholder: 'dataimport.data-description',
	required: true
  }
  ]
  
  let accesRight

  const accesRights = [
  {
  value: 'no-limits',
  name: 'no-limits-access-rights',
  label: 'dataimport.full-access'
  },
  {
  value: 'limited',
  name: 'limited-access-rights',
  label: 'dataimport.limited-access'
  }
  ]

  let formSubmitted = false
  let buttonDisabled = true

  $: if (formInputs.every((input) => input.val !== '')) {
  buttonDisabled = false
  } else {
  buttonDisabled = true
  }

  function submitForm() {
  fetch('https://prod-161.westeurope.logic.azure.com:443/workflows/ebea4f240b584d2db510cc42ead604f7/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=p74jCBoFRvjmAPaqYWwyXKGqIgTS_nyeCKu7pDPE96A', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				firstname: formInputs[0].val,
				lastname: formInputs[1].val,
				senderemail: formInputs[2].val,
				description: formInputs[3].val,
				receiveremail: 'datajalostamo@kuopio.fi',
				visibility: accesRight
			})
		})
		.then((response) => {
			if (response.ok) {
				formSubmitted = true
				formInputs.map((input) => input.disabled = true)
			} else {
				errorBox.set({ title: 'dataimport.error-title', description: 'dataimport.error-message'})
			}			
		})

	}

	let showErrorBox = false
	function closeErrorBox() {
		showErrorBox = false
	}
</script>

<ViewCardContainer pageTitle={$t('dataimport.page-title')}>
	<div class="relative">
		<div class="mb-8">
			<a href="/interfaces-import/1" use:link>
				<div class="p-4 md:py-6 border border-grey-700 hover:outline hover:outline-navy hover:outline-2 hover:border-navy hover:shadow-lg transition duration-150">
					<h3 class="text-navy mb-2">{$t('dataimport.api1-name')}</h3>
					<p>{$t('dataimport.api1-description')}</p>
				</div>
			</a>
		</div>
		{#if isLoggedIn }
			{#if checkIfHasAccess()}
				<h2 class="mb-2">{$t('dataimport.sub-title')}</h2>
				<p class="mb-10">{$t('dataimport.page-description')}</p>
				<h3 class="mb-2">{$t('datasource.token-title')}</h3>
        		<CopyToClipboard content={accessToken} />
				<h2>{$t('dataimport.api-description-title')}</h2>
				<SwaggerUI doc={'import-data-doc.yml'} />
			{:else}
				<h2 class="mb-2">{$t('dataimport.sub-title-no-access')}</h2>
				<p class="mb-12">{$t('dataimport.page-description-no-access')}</p>
				<div class="grid grid-cols-1 md:grid-cols-12">
					<div class="col-span-8">
						<h3 class="mb-4">{$t('dataimport.personel-info-title')}</h3>
						{#each formInputs as input}
							<div class="mb-4">
								{#if input.id === 'description'}
									<TextArea on:input={(e) => input.val = e.target.value} id={input.id} disabled={formSubmitted} label={$t(input.label)} placeholder={$t(input.placeholder)} required={input.required}></TextArea>
								{:else}
									<TextInput on:input={(e) => input.val = e.target.value} id={input.id} disabled={formSubmitted} label={$t(input.label)} placeholder={input.placeholder} required={input.required} />	
								{/if}
							</div>
						{/each}
						<h3 class="mt-10 mb-2">{$t('dataimport.access-rights-title')}</h3>
						<p class="mb-4">{$t('dataimport.access-rights-description')}</p>
						<RadioButton options={accesRights} bind:userSelected={accesRight} disabled={formSubmitted}/>
						<div class="mt-10">
							<BaseButton on:click={submitForm} disabled={buttonDisabled || formSubmitted} buttonType={formSubmitted ? 'success' : 'secondary'}>{formSubmitted ? $t('dataimport.button-form-sent') : $t('dataimport.button-send')}</BaseButton>
						</div>
					</div>
					{#if formSubmitted}
						<div class="col-span-12 mt-8">
							<AlertBox>{$t('dataimport.submitted-info')}</AlertBox>
						</div>
					{/if}
				</div>
			{/if}
		{:else}
			<div class="flex flex-col items-center">
				<BringDataIconBg />
				<p class="mb-8 mt-4 max-w-lg text-center">{$t('dataimport.log-in-description')}</p>
				<BaseButton on:click={startAuth} buttonType={'secondary'}>
					<span class="flex justify-center">
						<span class="mr-2">
							{$t('btn.sign-in')}
						</span>
						<LoginIcon color={'white'} />
					</span>
				</BaseButton>
			</div>
		{/if}
	</div>
</ViewCardContainer>